module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_duo_cuad_17.48058c58.png";